export const MESSAGE_USER_TYPE = {
  PARENT: 'parent',
  USER: 'user',
}
